import React from 'react';
import { Link } from 'react-router-dom';

const PageBreadcrumb = ({ title, description, items = [] }) => {
    return (
        <section className="relative overflow-hidden bg-[linear-gradient(120deg,_#0f172a,_#065f46,_#10b981)] py-14 text-white">
            <div className="absolute -top-10 left-10 h-44 w-44 rounded-full bg-white/10 blur-2xl"></div>
            <div className="absolute bottom-0 right-0 h-40 w-40 rounded-full bg-emerald-200/20 blur-2xl"></div>
            <div className="relative mx-auto max-w-7xl px-4">
                <h1 className="text-4xl font-black">{title}</h1>
                {description && <p className="mt-2 max-w-2xl text-emerald-100">{description}</p>}
                <div className="mt-4 inline-flex flex-wrap items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm backdrop-blur-sm">
                    <Link to="/" className="font-semibold text-emerald-100 hover:text-white">Home</Link>
                    {items.map((item, index) => (
                        <React.Fragment key={`${item.label}-${index}`}>
                            <span className="text-emerald-200">/</span>
                            {item.to ? (
                                <Link to={item.to} className="text-emerald-100 hover:text-white">{item.label}</Link>
                            ) : (
                                <span className="font-semibold text-white">{item.label}</span>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PageBreadcrumb;
